<template>
  <b-modal
    id="switch-child-info-modal"
    ref="switch-child-info-modal"
    body-class="p-10"
    centered
    title="Child Switch Confirmation"
    content-class="p-2"
  >
    <div>
      <p>
        Would you like to exit <strong>{{ previous_child_name }}</strong>'s application and switch to <strong>{{ new_child_name }}</strong>'s?
      </p>
    </div>

    <template #modal-footer>
      <div class="w-100 d-flex">
        <b-button
          class="border border-primary"
          variant="secondary"
          @click="cancel"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          class="ml-auto"
          @click="confirm"
        >
          Confirm
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>

import { BModal, BButton, } from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BButton,
  },
  data() {
    return {
      isLoading: false,
    }
  },
  props: {
    previous_child_name: {
      type: String,
      required: true,
    },
    new_child_name: {
      type: String,
      required: true,
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('confirm')
    },
  },
}
</script>

<style scoped>
</style>